<template>
  <div>
    <div v-if="roundId === null || isNaN(roundId)" class="mt-4">
      <h5 class="reviewedByText font-bold">You have to choose a round!</h5>
    </div>

    <div v-else class="mt-4">
      <div v-for="member in students" :key="member.id" class="selectionGrid mb-3">
        <p class="main-color font-bold align-self-center mb-0">
          {{ `${member.user.first_name} ${member.user.last_name}` }}
        </p>
        <b-badge class="align-self-center submittedBadge" :variant="hasStudentSubmitted(member.user.id) ? 'success' : 'secondary'">
          {{ hasStudentSubmitted(member.user.id) ? 'Submitted' : 'Pending' }}
        </b-badge>
        <p class="reviewedByText font-bold align-self-center mb-0">
          {{ returnHowManyMembersReviewed(member.user.id) }}
        </p>
        <div class="forwardButton">
          <b-button class="w-25" @click="setActiveUser(member.user.id)">
            <i class="bi bi-caret-right-fill"></i>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapGettersMixin from '../../../mixins/mapGettersMixin'
import { processPromisesMixin } from '../../../mixins/processPromisesMixin'
import { teamMembersMixin } from '../../../mixins/teamMembersMixin'
export default {
  name: 'TeamMemberSelect',
  mixins: [mapGettersMixin, processPromisesMixin, teamMembersMixin],
  props: {
    roundId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      fetchedData: [],
      peerReviews: [],
      students: [],
      supervisors: [],
      activeUser: '',
      memberName: ''
    }
  },
  beforeMount() {
    this.fetchPeerReviews()
  },
  methods: {
    setActiveUser(userId) {
      this.activeUser = userId
      const member = this.students.find((member) => member.user.id === userId)
      this.memberName = member ? `${member.user.first_name} ${member.user.last_name}` : ''
      this.$emit('userSelected', { userId: this.activeUser, memberName: this.memberName })
    },
    async fetchPeerReviews() {
      const response = await this.getRequestWithProjectIdPromise('peer-reviews/')
      const fetchedPeerReviews = response.data
      this.peerReviews = fetchedPeerReviews
    },
    returnHowManyMembersReviewed(activeUser) {
      return `${this.mapPeerReviews(activeUser).length} of ${this.students.length} have reviewed`
    },
    mapPeerReviews(activeUser) {
      return this.peerReviews.filter((review) => review.peer_review_round === this.roundId && review.targeted_student === activeUser)
    },
    hasStudentSubmitted(userId) {
      return this.peerReviews.some(
        (review) => review.peer_review_round === this.roundId && review.targeted_student === userId && review.is_self
      )
    }
  }
}
</script>

<style>
.selectionGrid {
  display: grid;
  grid-template-columns: 3fr 1fr 3fr 1fr;
  column-gap: 4em;
}

.forwardButton {
  width: 150px !important;
}

.submittedBadge {
  width: fit-content;
  font-size: 0.8rem;
  padding: 5px 10px;
}

.reviewedByText {
  color: grey;
}
</style>
